import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { SESSION_STORAGE, removeAllSessionStorage } from '../../shared/constants/storage.constants';
import { initState } from '../../state/actions/core.actions';

import { LocationService } from './location.service';

export const mobiprotektaGuard: CanActivateFn = (_route, state): boolean => {
    const locationService = inject(LocationService);
    const store = inject(Store);

    // Determine which portal the user is navigating to based on the context path
    const targetPortal = state.url.startsWith('/protekta') ? 'protekta' : 'mobiliar';
    const previousPortal = sessionStorage.getItem(SESSION_STORAGE.ACTIVE_PORTAL.key);

    // If portal switched, clear state and reload to get a fresh start
    if (previousPortal && previousPortal !== targetPortal) {
        removeAllSessionStorage();
        store.dispatch(initState());
        sessionStorage.setItem(SESSION_STORAGE.ACTIVE_PORTAL.key, targetPortal);
        locationService.reload();
        return false;
    }

    sessionStorage.setItem(SESSION_STORAGE.ACTIVE_PORTAL.key, targetPortal);
    return true;
};
